import { PAGE_ID } from "stores/route/utils/types";
import { COMPONENT_TYPE } from "types/Service";
import { TOOLS } from "./types";

export function getFarmsSectionsDescriptions() {
	return `- ${PAGE_ID.FARM_MAP}
è la prima FARM-SECTION visualizzata su selezione FARM.
Visualizza la mappa della FARM con la posizione dei macchinari, i sensori temperatura umidità pressione e co2, gli allarmi attivi.

- ${PAGE_ID.FARM_GROWUNITS}
visualizza tutti i COMPONENTS presenti nella FARM.

- ${PAGE_ID.FARM_PLANNER}
visualizza il piano di coltivazione programmate e fatte della FARM.

- ${PAGE_ID.FARM_TASKS}
visualizza tutte le TASKS attive e passate della FARM.

- ${PAGE_ID.FARM_CYCLES}
visualizza tutti i CYCLE di coltivazione attivi e passati della FARM.

- ${PAGE_ID.FARM_ATTACH}
delle foto inserite dagli operatori per segnalare problemi

- ${PAGE_ID.FARM_BI}
Visualizza una PIVOT-GRID.
Ulteriori info guarda i tools: ${TOOLS.SHOW_PIVOT_GRID}.

- ${PAGE_ID.FARM_PLC_ALERTS}
visualizza la lista allarmi PLC PLC-WARNING attivi nella FARM.
`
}

export function getGrowUnitsSectionsDescriptions() {
	return `- ${PAGE_ID.GROWUNIT_HOME}
Panoramica dello stato generale della GROWUNIT e i comandi di stop e play.

- ${PAGE_ID.GROWUNIT_MAIN}
Visualizza lo schema sinottico idraulico della GROWUNIT.
TANKS, VALVOLE, POMPE, pressione dei TUBI, ATTUATORI, SENSORI di livello, sensori di flusso.

- ${PAGE_ID.GROWUNIT_LAYERS}
visualizza lo stato di ogni LAYERS della GROWUNIT 
Lo stato delle LUCI, IRRIGAZIONE, FAN SPEED.
Il RECIPE attualmente in produzione.
I CYCLES attualmente sui LAYERS.

- ${PAGE_ID.GROWUNIT_FERTI}
permette di eseguire delle azioni come: fertilizzazione, irrigazione, drenaggio, svuotamento

- ${PAGE_ID.GROWUNIT_ADJ}
permette di eseguire delle azioni di aggiustamento su parametri come: PH (acidità), EC (conducibilità).

- ${PAGE_ID.GROWUNIT_LIGHTING}
visualizza lo stato dell'impianto di illuminazione e permette di eseguire azioni su di esso

- ${PAGE_ID.GROWUNIT_LIGHTING_PS}
visualizza lo stato dell'impianto di illuminazione specifico per la fase di crescita "planting" e permette di eseguire azioni su di esso

- ${PAGE_ID.GROWUNIT_CLIMATE}
visualizza lo stato dell'impianto di controllo climatico e permette di eseguire azioni su di esso

- ${PAGE_ID.GROWUNIT_IRRIGATION}
visualizza lo stato dell'impianto di irrigazione e permette di eseguire azioni su di esso
`
}

export function getComponentsDescriptions() {
	return `- ${COMPONENT_TYPE.GERMINATOR}
	E' il luogo a temperatura e umidità relativa controllata dove vengono fatte germinare le piantine prima di essere trapiantate nella GROWUNIT.
	- ${COMPONENT_TYPE.HVAC}
	E' il sistema di riscaldamento, ventilazione e condizionamento dell'aria presente nella FARM.
	- ${COMPONENT_TYPE.OSMOTIC_WATER}
	Sistema di trattamento dell'acqua osmotica. Visualizza il sinottico con gli EASY BLUE, O.W.TANKS, DAB.
	- ${COMPONENT_TYPE.CO2}
	Sistema di arricchimento di CO2. Visualizza sinottico con i livelli, visualizzazione e settaggio tempi e intervalli erogazione.
	- ${COMPONENT_TYPE.WATER_TREATMENT}
	Sistema di trattamento dell'acqua. Visualizza sinottico con i livelli dei serbatoi, visualizzazione e settaggio tempi e intervalli di erogazione dei trattamenti.
	- ${COMPONENT_TYPE.THERMAL_POWER_PLANT}
	Sistema raffreddamento a circuto acqua calda / fredda con contatore.
	- ${COMPONENT_TYPE.CLIMATE}
	Lettura e settaggio climatico cronologico di: temperature, humidity, fan-speed.
	Visualizza una timeline di mezz'ore della giornata.
`
}